import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, Pipe ,Input} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { DateTime } from 'luxon';
import {  result } from 'lodash-es';
import { FAQCategoryServiceProxy, GetFAQCategoryForViewDto } from '@shared/service-proxies/service-proxies';
@Component({
  selector: 'seek-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent extends AppComponentBase implements OnInit {
    faqcategories:Array<GetFAQCategoryForViewDto>;
  constructor(injector: Injector,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _faqCategoryServiceProxy:FAQCategoryServiceProxy) {
        super(injector);
     }

  ngOnInit() {
    this._faqCategoryServiceProxy.getAllLookUp("").subscribe((faqcategoryResult)=>{
        this.faqcategories=faqcategoryResult;
    });
  }

}
